module.exports = __webpack_public_path__ + "img/14brsjb_03.15db14a0.jpg";